import MuiAlert, { AlertColor } from '@mui/material/Alert'
import React from 'react'
import { AlertTitle } from '@mui/material'
import { useAlertStyles } from './Alert.styles'

type Props = {
    message: string
    severity: AlertColor
    sx: object
}

export const Alert = ({ message, severity, sx }: Props) => {
    const styles = useAlertStyles()
    return (
        <>
            <MuiAlert
                severity={severity}
                sx={{
                    ...styles.sx,
                    ...sx,
                }}
            >
                <AlertTitle marginBottom={0}>{message}</AlertTitle>
            </MuiAlert>
        </>
    )
}
